var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75007 17.7404C4.16961 17.3812 4.80088 17.4301 5.16005 17.8497C6.81225 19.7796 9.26306 21 12 21C14.7369 21 17.1877 19.7796 18.8399 17.8497C19.1991 17.4301 19.8304 17.3812 20.2499 17.7404C20.6695 18.0996 20.7184 18.7308 20.3592 19.1504C18.3433 21.5051 15.3457 23 12 23C8.65432 23 5.65673 21.5051 3.64077 19.1504C3.28159 18.7308 3.33053 18.0996 3.75007 17.7404Z",
    fill: "#50A682"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.98 2.00097C11.0899 2.54222 10.7402 3.07005 10.1989 3.17992C6.09132 4.01372 3 7.6469 3 11.9999C3 12.9423 3.14451 13.849 3.41186 14.7002C3.57735 15.2271 3.28437 15.7884 2.75746 15.9539C2.23056 16.1194 1.66925 15.8264 1.50376 15.2995C1.1762 14.2566 1 13.1479 1 11.9999C1 6.677 4.77972 2.23917 9.80107 1.21989C10.3423 1.11002 10.8701 1.45972 10.98 2.00097Z",
    fill: "#50A682"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0202 2.00097C13.13 1.45972 13.6579 1.11002 14.1991 1.21989C19.2205 2.23917 23.0002 6.677 23.0002 11.9999C23.0002 13.1479 22.824 14.2567 22.4964 15.2995C22.3309 15.8264 21.7696 16.1194 21.2427 15.9539C20.7158 15.7884 20.4228 15.2271 20.5883 14.7002C20.8557 13.849 21.0002 12.9423 21.0002 11.9999C21.0002 7.6469 17.9089 4.01372 13.8013 3.17992C13.26 3.07005 12.9103 2.54222 13.0202 2.00097Z",
    fill: "#50A682"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1996 8.78549C17.5942 9.17188 17.6009 9.80501 17.2145 10.1996L11.3395 16.1996C11.1516 16.3915 10.8944 16.4998 10.6258 16.5C10.3572 16.5002 10.0998 16.3923 9.91155 16.2007L6.78655 13.0189C6.39956 12.6249 6.40527 11.9917 6.79929 11.6047C7.19332 11.2177 7.82646 11.2234 8.21345 11.6175L10.6239 14.0718L15.7855 8.80038C16.1719 8.40576 16.805 8.3991 17.1996 8.78549Z",
    fill: "#50A682"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.3f90095c70673558ab5b9e984a3ad648.svg";
export { ForwardRef as ReactComponent };